import Vue from 'vue'
import Vuex from 'vuex'
import shop from './shop'
import cityList from './buyTicket/cityList'
import movieScheduling from './buyTicket/movieScheduling'
// import login from './login'
import coupon from './mine/coupon'
import confirmBuyCard from './card/confirmBuyCard'
import mine from './mine'
// vuex持久化插件
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    shop,
    cityList,
    coupon,
    movieScheduling,
    mine,
    confirmBuyCard
  },
  state: {
    userInfo:{
    },
    isWeixin: true,
    // 微信授权信息
    weChatInfo: '',
    // 短token
    shortToken: '0',
    // 长token
    longToken: '',
    // 心跳：服务器时间-本地时间
    serverTimeSiffer: '',
    // userType 1-U+会员，2-普通用户; avatar 头像
    userInfo: {},
    // 商城购物车
    shopCard: '',
    // 会员卡信息 - 会员卡列表点击到详情页
    cardListDetail: ''
  },
  getters: {
    // 获取服务器时间 差值 + 服务器时间
    getServerTime: state => {
      return +state.serverTimeSiffer + new Date().getTime()
    }
  },
  mutations: {
    memoryData(state, items) { //存储数据通用方法
      for(var i in items){
        state[i] = items[i]
      }
    },
    setIsWeixin (state, payload) {
      state.isWeixin = payload
    },
    setWeChatInfo (state, payload) {
      state.weChatInfo = payload
    },
    setShortToken (state, payload) {
      state.shortToken = payload
    },
    setLongToken (state, payload) {
      state.longToken = payload
    },
    setServerTimeSiffer (state, payload) {
      state.serverTimeSiffer = payload
    },
    setUserInfo (state, payload){
			state.userInfo = payload;
		},
    setShopCard (state, payload) {
      state.shopCard = payload
    },
    setCardListDetail (state, payload) {
      state.cardListDetail = payload
    }
  },
  actions: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js